var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-appbar'),_c('router-view',{style:(_vm.$vuetify.breakpoint.mdAndUp ? 'margin-top: 60px' : 'margin-top: 52px')}),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }